import type { Keystroke } from "./keystroke";

/** 記録済みマクロのレジストリ。`"`（テキストレジスタ）とは別の名前空間で持つ。 */
export interface Macros {
  readonly entries: ReadonlyMap<string, readonly Keystroke[]>;
}

export const EMPTY_MACROS: Macros = { entries: new Map() };

export function getMacro(macros: Macros, name: string): readonly Keystroke[] | undefined {
  return macros.entries.get(name);
}

export function withMacro(macros: Macros, name: string, keys: readonly Keystroke[]): Macros {
  const entries = new Map(macros.entries);
  entries.set(name, keys);
  return { entries };
}

export interface MacroRecording {
  readonly name: string;
  readonly keys: readonly Keystroke[];
}
